/**
 * Validate a user's SQL query against an expected input
 * @param {string} userInput - The SQL query provided by the user
 * @param {string} expectedInput - The expected SQL query to compare against
 * @returns {boolean} True if the query is valid and matches the expected input, False otherwise
 */
function validateSqlQuery(userInput, expectedInput) {

    // Helper function to normalize the order of columns in select statement
    function normalizeSelectOrder(query) {
        return query.replace(/SELECT\s+(.*?)\s+FROM/gi, (match, columns) => {
            const sortedColumns = columns
                .split(',')
                .map(col => col.trim())
                .sort()
                .join(', ');
            return `SELECT ${sortedColumns} FROM`;
        });
    }

    // Helper function to normalize SQL query
    function normalizeQuery(query) {
        let normalized = query;

        normalized = normalizeSelectOrder(normalized);

        // Common normalizations
        normalized = normalized.replace(/\s+/g, '').trim();

        normalized = normalized.replace(/;/g, '');

        normalized = normalized.toLowerCase();

        normalized = normalized.replace(/--.*$/gm, ''); // Remove line comments
        normalized = normalized.replace(/\/\*[\s\S]*?\*\//g, ''); // Remove block comments

        normalized = normalized.replace(/\b(SELECT|FROM|WHERE|JOIN|ON|GROUP BY|ORDER BY|HAVING|LIMIT|OFFSET|INSERT|INTO|VALUES|UPDATE|SET|DELETE)\b/gi, match =>
            match.toUpperCase()
        );

        normalized = normalized.replace(/\s*=\s*/g, ' = ');
        normalized = normalized.replace(/\s*>\s*/g, ' > ');
        normalized = normalized.replace(/\s*<\s*/g, ' < ');

        return normalized;
    }

    // Helper function to validate basic SQL syntax
    function isValidSql(sql) {
        // Basic check for SQL-like structure
        const sqlKeywords = [
            'SELECT', 'INSERT', 'UPDATE', 'DELETE', 'CREATE',
            'ALTER', 'DROP', 'FROM', 'WHERE', 'JOIN'
        ];

        // Convert to uppercase for case-insensitive check
        const upperSql = sql.toUpperCase();

        // Check if query contains any SQL keywords
        return sqlKeywords.some(keyword =>
            upperSql.includes(keyword)
        );
    }

    // First, validate the SQL syntax
    if (!isValidSql(userInput)) {
        return false;
    }

    // Normalize both inputs
    const normalizedUserInput = normalizeQuery(userInput);
    const normalizedExpectedInput = normalizeQuery(expectedInput);

    // Compare normalized queries
    return normalizedUserInput === normalizedExpectedInput;
}

module.exports = validateSqlQuery;
